import axios from "axios";
import { SERVER_BASE_URL } from "../../constants/constants";


export const ResultsService = {
    async sendResults(token: string, results: any) {
        const url = SERVER_BASE_URL + `api/game/results`;
        return axios({
            method: 'post',
            url: url,
            data: results,
            headers: {
                'x-auth-token': token,
            }
        });
    },

    async getLeaderboard(token: string, server: string) {
        // server can be "ALPHA" | "BETA" | "GAMMA" | "OMEGA" | "ALL"
        const url = `${SERVER_BASE_URL}api/game/results`;
        return axios.get(url, {
            headers: {
                'x-auth-token': token
            },
            params: {
                'server': server
            }
        });
    },

    async deleteResult(token: string, server: string, id: string) {
        // server is the server the result belongs to (required for admin cross-server delete)
        const url = `${SERVER_BASE_URL}api/game/results`;
        return axios.delete(url, {
            headers: {
                'x-auth-token': token
            },
            data: {
                'resultId': id,
                'server': server
            }
        })
    },

    async sendReward(token: string, reward: any) {
        const url = SERVER_BASE_URL + `api/game/reward`;
        return axios({
            method: 'post',
            url: url,
            data: reward,
            headers: {
                'x-auth-token': token,
            }
        });
    },

    async getRewardAvailability(token: string) {
        const url = SERVER_BASE_URL + `api/game/reward/availability`;
        return axios.get(url, {
            headers: {
                'x-auth-token': token,
            }
        });
    },

    async getUsers(token: string) {
        const url = SERVER_BASE_URL + `api/game/download/users`;
        return axios({
            method: 'get',
            url: url,
            headers: {
                'x-auth-token': token,
            }
        });
    },
    async getGames(token: string, server: string = "ALL") {
        // server: "ALL" | "ALPHA" | "BETA"
        const url = SERVER_BASE_URL + `api/game/download/games`;
        return axios.get(url, {
            headers: { 'x-auth-token': token },
            params: { server }
        });
    },

    async getCompleteGames(token: string, server: string = "ALL") {
        // server: "ALL" | "ALPHA" | "BETA"
        const url = SERVER_BASE_URL + `api/game/download/complete_games`;
        return axios.get(url, {
            headers: { 'x-auth-token': token },
            params: { server }
        });
    },
    async getStatus(token: string) {
        const url = SERVER_BASE_URL + `api/status`;
        return axios.get(url, {
            headers: { 'x-auth-token': token }
        });
    },

    async getRewardList(token: string) {
        // Admin-only. Returns { claimed: [...], unclaimed: [...] }.
        const url = SERVER_BASE_URL + `api/game/reward/list`;
        return axios.get(url, {
            headers: { 'x-auth-token': token }
        });
    },

    async assignReward(token: string, username: string, store: string) {
        // Admin-only. Sets User.store for the target user (and backfills result_id).
        const url = SERVER_BASE_URL + `api/game/reward/assign`;
        return axios.post(url, { username, store }, {
            headers: { 'x-auth-token': token }
        });
    },

    async sendProgress(token: string, progress: any) {
        const url = SERVER_BASE_URL + `api/game/progress`;
        return axios({
            method: 'post',
            url: url,
            data: progress,
            headers: {
                'x-auth-token': token,
            }
        });
    },

}